module.exports = __webpack_public_path__ + "static/media/rulesDollar.ae842d13.svg";